module.exports = __webpack_public_path__ + "img/1.613c71f7.png";